import type { WorkBook } from 'xlsx-js-style';
import * as XLSX from 'xlsx-js-style';

export function workbookToXlsxBlob(wb: WorkBook): Blob {
  const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx', cellStyles: true });
  return new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
}
